
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Loan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TLoan"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"existingcustomers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"institution"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enhanced_loans"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicInstitution"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"loantiers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interest_rate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxterm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxamount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minterm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minamount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicImage"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"plan_features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicPlanFeature"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ratetype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicUrl"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TLoanSearch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rate_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"term"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":608}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/shared/image\"\n#import \"@/graphql/fragments/shared/institution\"\n#import \"@/graphql/fragments/shared/plan-feature\"\n#import \"@/graphql/fragments/shared/url\"\n\nfragment Loan on TLoan {\n  code\n  existingcustomers\n  name\n  institution {\n    enhanced_loans\n    ...BasicInstitution\n  }\n  loantiers {\n    apr\n    interest_rate\n    maxterm\n    maxamount\n    minterm\n    minamount\n  }\n  offer_icon {\n    ...BasicImage\n  }\n  plan_features {\n    ...BasicPlanFeature\n  }\n  ratetype\n  slug\n  url {\n    ...BasicUrl\n  }\n}\n\nfragment LoanSearch on TLoanSearch {\n  amount\n  code\n  rate_type\n  term\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/image").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/institution").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/plan-feature").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/url").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Loan"] = oneQuery(doc, "Loan");
        
        module.exports["LoanSearch"] = oneQuery(doc, "LoanSearch");
        
